import {
    getAuth,
    signInWithPopup,
    GoogleAuthProvider,
    signOut
} from "firebase/auth";

const auth = getAuth();

export const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    return await signInWithPopup(auth, provider);
};

export const logoutUser = async () => {
    return await signOut(auth);
};

export default auth;